import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "q-py-xs text-bold"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "q-py-xs text-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_ctx.element && _ctx.element.elType === 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.parentChain && _ctx.parentChain.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('projection_parents')), 1))
          : _createCommentVNode("", true),
        (_ctx.parentChain && _ctx.parentChain.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parentChain, (p_item, p_index) => {
                return (_openBlock(), _createElementBlock("div", { key: p_index }, _toDisplayString(p_item.Name), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.theModel && _ctx.theModel.Roles && _ctx.theModel.Roles.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('projection_dest')), 1),
              _createVNode(_component_q_select, {
                flat: "",
                modelValue: _ctx.rolesModel,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rolesModel) = $event)),
                class: "no-select-border q-mb-xs",
                "hide-bottom-space": "",
                "fill-input": "",
                "option-label": "Name",
                "option-value": "Id",
                multiple: "",
                "label-slot": false,
                "bottom-slots": false,
                dense: "",
                outlined: "",
                "input-debounce": "500",
                label: "",
                ref: "roles_select",
                "hide-dropdown-icon": true,
                options: _ctx.theModel.Roles
              }, {
                "no-option": _withCtx(() => [
                  _createVNode(_component_q_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, { class: "text-grey" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('no_data_found')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue", "options"])
            ], 64))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}